import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {LevelUpPage} from './level-up';
import {PipesModule} from "../../../../shared/pipes/pipes.module";

@NgModule({
  declarations: [
    LevelUpPage,
  ],
  imports: [
    PipesModule,
    IonicPageModule.forChild(LevelUpPage),
  ],
})
export class LevelUpPageModule {}



// WEBPACK FOOTER //
// ./src/modules/core/pages/level-up/level-up.module.ts